module.exports = __webpack_public_path__ + "badge-like.svg?2e6e76a4865c58daa9b3141fec5e69b2";


//////////////////
// WEBPACK FOOTER
// ./public/images/site/badge-like.svg
// module id = 481
// module chunks = 0